module.exports = __webpack_public_path__ + "img/513.2a3d7a0a.jpg";